import { render, staticRenderFns } from "./YoukeChuyouXingweiFenxi.vue?vue&type=template&id=5a008370&scoped=true&"
import script from "./YoukeChuyouXingweiFenxi.vue?vue&type=script&lang=js&"
export * from "./YoukeChuyouXingweiFenxi.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a008370",
  null
  
)

export default component.exports